import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ActivityTabs, BookingBehavior, buttonTypes, ComponentTypes } from 'src/app/shared/constants/commonenums';
import { ButtonValue } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { OpenBookingDTO } from 'src/app/shared/Models/OpenBookingDTO';
import { PartyType, PaymentGateways, PaymentStates } from 'src/app/shared/Models/PartyModels';
import { ValidationMessageType } from 'src/app/shared/Models/ResultModels';
import { BookedSessionsDTO, BookingActivity, ClassType, SessionBookingDTO } from 'src/app/shared/Models/SessionBookingDTO';
import { LockCartDTO, RegisterReservationAttemptCartDTO } from 'src/app/shared/Models/SlotLockModels';
import { operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { PopupService } from 'src/app/shared/services/popup.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cart-details',
  templateUrl: './cart-details.component.html',
  styleUrls: ['./cart-details.component.scss']
})
export class CartDetailsComponent extends Utilities implements OnInit, AfterViewInit {
  CartList: any = [];
  proceedBtn: ButtonValue;
  cancelBtn: ButtonValue;
  continueBtn: ButtonValue;
  backToSummaryBtn: ButtonValue;
  OperationCurrency: any;
  charges = [{
    key: 'Session Charge',
    value: '280'
  }];
  Total = 890;
  Subscriptions: Subscription = new Subscription();
  IframeURL: SafeResourceUrl;
  PaymentGateway: PaymentGateways;
  paymentData: any;
  isSplitPayment: any;
  waiverFormTrancationId: any;
  reservationAttemptIDsList: any;
  cartLockResultIds: any = [];
  IsLockTimer = false;
  TotalCartValue = 0;
  TotalCartPayment = 0;
  showIframeURL = false;
  cancelBookingBtn: ButtonValue;
  showNoResults = false;
  availableSpecialMeals = [];
  clearCartDialogRef: MatDialogRef<any>;
  showIframeLoader = false;
  cancelledCartItems = false;

  constructor(public gs: GuestService, public ts: TranslateService, private sanitizer: DomSanitizer,
    private ps: PopupService, public dialog: MatDialog) {
    super(dialog);
    this.gs.TabChange$.subscribe(data => {
      if (data === ActivityTabs.CartDetails && this.cancelledCartItems) {
        this.refreshCartDetails();
      }
    })
  }

  ngOnInit(): void {

    this.getCartList();
    this.proceedBtn = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('proceedPayment'),
      customclass: "payment-container__custom-class"
    };
    this.cancelBtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('clearCart'),
      customclass: "payment-container__custom-class"
    };
    this.continueBtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('continueBooking'),
      customclass: "payment-container__custom-class"
    };
    this.backToSummaryBtn = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('BackToCartSummary'),
      customclass: "payment-container__custom-class",
      disbaledproperity: false
    }

    this.cancelBookingBtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('cancel'),
      customclass: "payment-container__custom-class"
    };

    this.Subscriptions.add(
      this.gs.overlapBookingproceedEvent.subscribe(x=>{
        if(x.proceedOverlapBooking && !x.isOverlapErrorFromValidateCartApi) {
          this.bookCartData();
        }
      })
    )
  }

  generateCartId() {
    if (this.CartList && this.CartList.length) {
      this.CartList.forEach((cartItem, index) => {
        cartItem.CartId = 'CartItem' + index
        cartItem.TableList = cartItem.TableNames?.split(',');
        cartItem.StaffsList = cartItem.Staffs?.split(',')
      });
    }
  }
  getCartList() {
    this.CartList = JSON.parse(sessionStorage.getItem('CartList'));
    if (this.CartList && this.CartList.length) {
      this.generateCartId();
      this.gs.cartCount = this.CartList.length;
      this.showNoResults = false;
    } else {
      this.showNoResults = true;
    }
    this.OperationCurrency = this.gs.restaurantWidgetSettings$.value.OperationCurrency;
    this.availableSpecialMeals = this.gs.restaurantWidgetSettings$.value.AvailableSpecialMeals;
  }

  refreshCartDetails() {
    this.getCartList();
    if (this.CartList && this.CartList.length) {
      this.LockCartData();
    }
    this.gs.editFromCart = false;
    this.gs.isbookingCompleted = false;
    this.cancelledCartItems = false;
  }

  ngAfterViewInit() {
    this.Subscriptions.add(this.gs.cancelledCartItems$.subscribe(action => {
      if (action === true) {
        this.CartList = JSON.parse(sessionStorage.getItem('CartList'));
        this.showNoResults = true;
        this.cancelledCartItems = true;
      }
    }));
    this.Subscriptions.add(this.ps.actionEnabled$.subscribe(x => {
      if (x == ComponentTypes.clearCart && this.clearCartDialogRef) {
        this.clearCartDialogRef.close();
        this.clearCart();
      }
    }));
    if (this.CartList && this.CartList.length) {
      this.LockCartData();
    }
    this.gs.editFromCart = false;
    this.gs.isbookingCompleted = false;
  }

  proceedBooking() {
    this.gs.editFromCart = false;
    this.registerReservationAttempt();
  }


  registerReservationAttempt() {
    let req = [] as RegisterReservationAttemptCartDTO[];
    this.CartList.filter(x => x.SlotLockResult).forEach(cartObj => {
      req.push({
        ActivityId: cartObj.SpecialMealId,
        PartySize: Number(cartObj.Size),
        Sessions: cartObj.Sessions,
        Slots: cartObj.RatePlanTimeSlots ? cartObj.RatePlanTimeSlots : [],
        BookingBehavior: cartObj.BookingBehavior,
        TableIds: cartObj.TableIds,
        InstructorIds: cartObj.StaffId,
        CoverTypes: cartObj.CoverTypes,
        BookingTypes: cartObj.BookingTypes,
        ClientIP: '',
        ForceIFrameUrl: false,
        SeatingTypeIds: [],
        PartyId: null,
        CartId: cartObj.CartId,
        IsMemberActive: cartObj.Contact.IsMemberActive,
        MemberType: cartObj.Contact.MemberType
      });
    });
    this.Subscriptions.add(this.gs.RegisterReservationAttemptCart(req).subscribe(data => {
      this.paymentData = data;
      if (data.CreditCardIframeUrl) {
        this.PaymentGateway = data.PaymentGateway
        this.setReservationAttemptResponse()

        this.reservationAttemptIDsList = this.getRegisterreservationAttemptIds()
        this.TotalCartPayment = data.PaymentAmount;
        this.showIframeURL = true;
        this.LoadPayment(data.CreditCardIframeUrl);
      } else if (data.ShouldCreditCardBeEntered && !data.CreditCardIframeUrl) {
        this.gs.setMessageState(this.ts.instant('SorryForPaymentOffline'), 0);
      }
      else {
        this.showIframeURL = false;
        this.bookCartData();
      }
    }));
  }

  setReservationAttemptResponse() {
    this.CartList.forEach((cartItem) => {
      var attemptResponse = this.paymentData.ResponseDTOs.filter(response => response.CartId == cartItem.CartId)[0];
      if (attemptResponse) {
        cartItem.ReservationAttemptResponse = attemptResponse;
      }
    });
  }

  getRegisterreservationAttemptIds() {
    return this.paymentData.ResponseDTOs.map((attempt) => {
      if (attempt.Slots && attempt.Slots.length > 0) {
        return attempt.Slots.map((slot) => { return slot.ReservationAttemptId }).flat();
      }
      else {
        return attempt.ReservationAttemptId;
      }
    }).flat();
  }

  LoadPayment(iframeURl) {
    if (iframeURl) {
      this.showIframeLoader = true;
      this.IframeURL = this.sanitizer.bypassSecurityTrustResourceUrl(iframeURl + "&origin=" + window.location.origin);
      setTimeout(() => {
        this.showIframeLoader = false;
      }, 5000)
    }
  }

  bookCartData() {
    this.CartList = this.CartList.filter(x => x.SlotLockResult);
    this.CartList.forEach(cartItem => {
      this.mapLockAndReservationAttemptInfo(cartItem);
    });
    this.Subscriptions.add(this.gs.bookCart(this.CartList, this.gs.allowOverlapBookings).subscribe(data => {
      if (data?.Payload && data?.ValidationMessages?.filter(msg => msg.Type == ValidationMessageType.Error || msg.Type == ValidationMessageType.Consent).length === 0 && !data?.ExceptionMessage) {
        this.gs.setMessageState(this.ts.instant('cartBookSuccess'), 1);
        this.gs.isbookingCompleted = true;
        this.gs.offTimer();
        const bookedParties = data;
        this.CartList.forEach(item => {
          item.Parties = bookedParties.filter(x => x.CartId === item.CartId);
          return item;
        });
        this.gs.bookedCartList = this.CartList;
        this.showIframeURL = false;
        sessionStorage.setItem('CartList', JSON.stringify([]));
        this.gs.cartCount = 0;
      }
    }));
  }

  mapLockAndReservationAttemptInfo(cartItem) {
    if (cartItem.BookingBehavior == BookingBehavior.ClassOrSession) {
      cartItem.Sessions.LockId = cartItem.SlotLockResult?.SlotLockIdDTO?.Id;
      cartItem.ReservationAttemptId = cartItem.ReservationAttemptResponse?.ReservationAttemptId;
    }
    else {
      let reservatioAttemptWithSlotMapList = [];
      cartItem.Slots.forEach(slot => {
        slot.LockId = cartItem.SlotLockResult[slot.Time]?.SlotLockIdDTO?.Id;
      });
      cartItem.ReservationAttemptResponse?.Slots.forEach(slot => {
        reservatioAttemptWithSlotMapList.push({ SlotTime: slot.LocalTime, ReservationAttemptId: slot.ReservationAttemptId });
      });
      cartItem.ReservationAttemptIdWithSlotDTOList = reservatioAttemptWithSlotMapList
    }
  }

  cancelBooking() {
    const popUpMessage = [{
      confirmationMessage: this.ts.instant('confirmClearCartMessage'),
      dialogTitle: this.ts.instant('clearCart'),
      showAlert: true,
      isScrolable: true
    }];
    const height = '300px';
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.clearCartDialogRef = this.openCustomPopup(componentDetails, ComponentTypes.clearCart, '450px', height, true, '', this.ts.instant('Yes'),
      this.ts.instant('No'), true)
  }

  clearCart() {
    sessionStorage.setItem('CartList', JSON.stringify([]));
    this.gs.CartBookingList$.next({});
    this.gs.TabChange$.next(ActivityTabs.BookingSelection);
  }

  continueBooking() {
    this.gs.offTimer();
    if (this.cartLockResultIds && this.cartLockResultIds.length) {
      this.gs.unlockCartURL(this.cartLockResultIds);
    }
    this.gs.setMessageState('', 0);
    this.gs.SaveBookingObj = null;
    this.gs.SessionBookingObj = {} as SessionBookingDTO;
    this.gs.slots_holder = [];
    this.gs.selectedOpenBookingSlots = {};
    this.gs.openBookingData = {} as OpenBookingDTO;
    this.gs.SelectedClassSchedule$.next([]);
    this.gs.operation = operationType.create;
    this.gs.BookNew$.next(true);
    this.gs.bookingSection$.next(BookingActivity.ClassBooking);
    this.gs.TabChange$.next(ActivityTabs.BookingSelection);
    this.gs.RatePlanList$.next(null);
    this.gs.ispaymentInvolvedInfo = null;
    this.gs.reservationAttemptInfo = null;
    this.gs.additionalGuestPage = false;
    this.gs.additionalGuestRequired = 0;
    this.gs.slotLockId = 0;
    this.gs.RefundAmount = 0;
    this.gs.TotalRefundAmount = 0;
    this.gs.lockResult = null;
    this.gs.editPartyData$.next(null);
    this.gs.BookAnotherReservation.next(true);
    this.gs.editFromCart = false;
    this.gs.isSummaryFromCart = false;
  }

  editItem(party, index) {
    if (this.cartLockResultIds && this.cartLockResultIds.length) {
      this.gs.unlockCartURL(this.cartLockResultIds);
    }

    let partyData = this.setPartyDetails(party, index);
    this.gs.operation = operationType.edit;
    this.gs.selectedCartIndex = index;
    partyData.Slots = [];
    this.setBookingType(party);
    if (party.BookingBehavior === BookingBehavior.ClassOrSession) {
      this.setPartySessionClassInfo(partyData, party);
      this.gs.SelectedActivity$.next(party.SelectedActivity);
      this.gs.TabChange$.next(ActivityTabs.ActivitySelection);
    } else if (party.BookingBehavior === BookingBehavior.OpenBooking) {
      partyData.Slots = party.Slots;
      this.gs.TabChange$.next(ActivityTabs.BookingSelection)
    } else if (party.BookingBehavior === BookingBehavior.PrivateLesson) {
      partyData.Slots = party.Slots;
      this.gs.SelectedActivity$.next(party.SelectedActivity);
      this.gs.TabChange$.next(ActivityTabs.PrivateLesson)
    }
    this.gs.editFromCart = true;
    this.gs.offTimer();
    this.gs.editPartyData$.next(partyData);
  }
  setPartyDetails(partyData, index) {
    let party = {} as any;
    party.Size = partyData.Size;
    party.CoverTypeQuantities = partyData.CoverTypes;
    party.BookingTypeQuantities = partyData.BookingTypes;
    party.StartDate = partyData.StartDate
    party.EndDate = partyData.EndDate;
    party.TableIds = partyData.TableIds;
    party.StaffId = partyData.InstructorIds;
    party.StaffIds = partyData.InstructorIds;
    party.Contact = partyData.Contact;
    party.BookedSessions = [];
    party.ReservedFor = partyData.StartDate;
    party.Location = partyData.TableIds;
    party.WaiverFormTrancationId = partyData.WaiverFormTrancationId;
    return party;
  }

  setPartySessionClassInfo(partyData, party) {

    if (party.Sessions.Sessions && party.Sessions.Sessions.length) {
      party.Sessions.Sessions.forEach(session => {
        session.SessionIds.forEach(id => {
          partyData.BookedSessions.push({
            Id: null,
            PartyId: null,
            ActivitySessionId: id,
            BookedDate: session.Date,
            BookingSize: partyData.Size,
            SessionState: 0,
            RatePlanAmount: null
          })
        });

      });
    } else {
      partyData.SessionGroupId = party.SessionGroupId;
    }
  }

  removeItem(party, index) {
    const removeItem = this.CartList.splice(index, 1);
    this.calculateRatePlanTotal();
    this.gs.setMessageState(this.ts.instant('reservationRemoved'), 1)
    if (removeItem.SlotLockResult) {
      let unlockCartObj = [];
      unlockCartObj.push(this.cartLockResultIds[index]);
      this.gs.unlockCartURL(unlockCartObj);
    }
    this.gs.cartCount = this.CartList.length;
    sessionStorage.setItem('CartList', JSON.stringify(this.CartList));
    if (!this.CartList.length) {
      this.gs.TabChange$.next(ActivityTabs.BookingSelection)
    }
  }
  LockCartData() {
    let req = [] as LockCartDTO[];
    this.CartList.forEach(cartObj => {
      req.push({
        ActivityId: cartObj.Id,
        Sessions: cartObj.Sessions ? cartObj.Sessions?.Sessions : null,
        SessionGroupId: cartObj.SessionGroupId ? cartObj.SessionGroupId : null,
        StartDate: cartObj.StartDate,
        LockIdToIgnore: null,
        ClassType: cartObj.SpecialMealId ? this.setClassType(cartObj.SpecialMealId) : null,
        ReservationIdToIgnore: null,
        PartySize: Number(cartObj.Size),
        SeatingAreaId: cartObj.SeatingAreaId,
        IsCommunalTable: false,
        FromWebsite: true,
        SeatingTypeId: cartObj.SeatingTypeId,
        Slots: cartObj.RatePlanTimeSlots ? cartObj.RatePlanTimeSlots : [],
        BookingBehaviour: cartObj.BookingBehavior,
        TableIds: cartObj.TableIds,
        InstructorIds: cartObj.StaffId ? cartObj.StaffId : null,
        GuestTypes: cartObj.CoverTypes,
        BookingTypes: cartObj.BookingTypes,
        IsMemberActive: cartObj.Contact.IsMemberActive,
        MemberType: cartObj.Contact.MemberType,
        CartId: cartObj.CartId
      })
    });
    this.Subscriptions.add(this.gs.LockCartSessionSlots(req).subscribe(data => {
      this.setCartLockandRatePlanData(data.Payload);
    }));
  }
  setClassType(id) {
    if (id !== null) {
      let meal = this.availableSpecialMeals.find(meal => meal.Id === id);
      return meal.ClassType;
    } else {
      return null;
    }
  }
  setCartLockandRatePlanData(CartLockData) {
    this.cartLockResultIds = [];
    this.CartList.forEach((cartItem, index) => {
      let cartItemLockInfo = CartLockData.filter(lck => lck.CartId == cartItem.CartId)[0];
      if (cartItemLockInfo) {
        cartItem.SlotLockResult = cartItemLockInfo.SlotLockResultDTO;
        cartItem.RatePlan = cartItemLockInfo.RatePlanTotal;
        this.setLockIds(cartItemLockInfo);
        if (cartItem.RatePlan?.TotalRatePlan) {
        }
        return cartItem;
      }
    });
    this.calculateRatePlanTotal();
  }

  calculateRatePlanTotal() {
    this.TotalCartValue = 0;
    this.CartList.forEach((cartItem, index) => {
      if (cartItem.RatePlan) {
        this.TotalCartValue = this.TotalCartValue + (cartItem.RatePlan.TotalDepositAmount > 0 ? cartItem.RatePlan.TotalDepositAmount : cartItem.RatePlan.TotalRatePlan);
        //this.TotalMembershipDiscount = this.TotalMembershipDiscount + ratePlanData.TotalMemberShipVariant;
      }
    });
  }

  setLockIds(slotLockData) {
    if (slotLockData && slotLockData !== null) {
      let cartItem = this.CartList.filter(item => item.CartId == slotLockData.CartId)[0];
      if (slotLockData.SlotLockResultDTO?.SlotLockIdDTO?.Id) {
        this.setTimer(slotLockData.SlotLockResultDTO);
        this.cartLockResultIds.push({ LockId: slotLockData.SlotLockResultDTO?.SlotLockIdDTO.Id, Type: cartItem?.BookingBehavior });
      } else {
        if (slotLockData.SlotLockResultDTO) {
          Object.keys(slotLockData.SlotLockResultDTO).forEach(key => {
            if (slotLockData.SlotLockResultDTO[key]?.SlotLockIdDTO?.Id) {
              this.setTimer(slotLockData.SlotLockResultDTO[key]);
              this.cartLockResultIds.push({ LockId: slotLockData.SlotLockResultDTO[key]?.SlotLockIdDTO?.Id, Type: cartItem?.BookingBehavior });
            }
          });
        }
      }
    }
  }

  setTimer(lockResult) {
    if (!this.IsLockTimer) {
      this.IsLockTimer = true;
      let timer = moment(lockResult.ExpiresAt).diff(moment(lockResult.LockedAt), "seconds");
      if (timer) {
        this.gs.showTimer = true;
        this.gs.runTimer(timer);
      }
    }
  }


  @HostListener('window:message', ['$event'])
  onMessage({ origin, data }) {
    if (origin != environment.authorizeIframeResponseOrigin && origin != environment.rGuestPayIframeResponsOrigin) { // set your origin
      return false;
    }
    var rGuestPayRespose = data;
    var payResponse = data;
    if (typeof data != "object") {
      rGuestPayRespose = JSON.parse(data);
    }
    if ((data.type == "txn-completed" && data.transactionInfo && data.transactionInfo.transactionInfo && data.transactionInfo.transactionInfo.payments) || (rGuestPayRespose && (rGuestPayRespose.code || rGuestPayRespose.gatewayResponseData))) {
      if (this.PaymentGateway == PaymentGateways.AuthorizePay) { //Authorize Pay 

        var transInfo = payResponse.transactionInfo.transactionInfo;

        if (transInfo.errorMessage || transInfo.successCode != 1) {
          if (transInfo.errorMessage) {
            this.gs.setMessageState(transInfo.errorMessage, 0);
          }
          else {
            this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
          }
        } else if (payResponse && transInfo && transInfo.successCode == 1) {

          var transactions = this.processTransactions(transInfo);
          var dto = {
            RestaurantId: this.gs.restaurantWidgetSettings$.value.RestaurantId,
            PartyId: null,
            SlotLockIds: this.cartLockResultIds.map(x => x.LockId),
            BookingID: null,
            TokenType: "",
            PaymentAmount: transInfo.paidAmount,
            PaymentGateway: this.PaymentGateway,
            AuthorizeTransactions: transactions,
            ReservationAttemptIds: this.reservationAttemptIDsList,
            SplitPaymentReload: this.isSplitPayment
          };

          this.UpdateReservationAttempt(dto);
        } else {
          this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
        }
      }
      else {
        if (rGuestPayRespose.code && rGuestPayRespose.code != "100") {
          rGuestPayRespose = JSON.parse(data);
          if (rGuestPayRespose.validationErrors && rGuestPayRespose.validationErrors.length > 0) {
            var errorString = "";
            rGuestPayRespose.validationErrors.forEach(function (error, i, arr) {
              errorString = error.fieldName + " " + error.value + "\n";
            })
            this.gs.setMessageState(errorString, 0);
          }
          else if (rGuestPayRespose && rGuestPayRespose.gatewayResponseData && rGuestPayRespose.gatewayResponseData.message) {
            alert(rGuestPayRespose.gatewayResponseData.message);
          }
          else {
            this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
          }
        }
        else if (rGuestPayRespose && rGuestPayRespose.gatewayResponseData && rGuestPayRespose.gatewayResponseData.code == "100") {
          let callbackDto = {
            ReservationAttemptIds: this.reservationAttemptIDsList,
            CardNumber: rGuestPayRespose.cardInfo.accountNumberMasked,
            ExpirationDate: new Date(data.cardInfo.expirationYearMonth.substring(0, 4) + '-' + data.cardInfo.expirationYearMonth.substring(4) + '-01'),
            CVC: "",
            FirstNameHolder: "",
            LastNameHolder: "",
            AddressLine1: "",
            AddressLine2: "",
            City: "",
            State: "",
            PostalCode: "",
            TokenType: "",
            Token: data.token
          };
          this.UpdateReservationAttempt(callbackDto);
        }
        else {
          this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
        }
      }
    }
    else if (data.type == "txn-completed" && data.transactionInfo) {
      this.waiverFormTrancationId = data.transactionInfo.authorizeTransactionID;
      let invoiceId = data.transactionInfo.invoiceID
      if (this.gs.ispaymentInvolvedInfo && this.gs.ispaymentInvolvedInfo.CreditCardRequired) {
        if (this.gs.reservationAttemptInfo) {
          if (this.gs.reservationAttemptInfo.CreditCardIFrameURL) {
            this.LoadPayment(this.gs.reservationAttemptInfo.CreditCardIFrameURL)
          }
          else {
            this.gs.setMessageState(this.ts.instant('SorryForPaymentOffline'), 0);
          }
        } else {
          this.registerReservationAttempt();
        }
      }
      else {
        this.bookCartData();
      }
    }
  }

  processTransactions(transInfo) {
    var transactions = transInfo.payments;
    var authorizeTransactions = [];

    if (transactions && transactions.length > 0) {
      transactions.forEach(transaction => {
        if (transaction.successCode == 1) {
          var name = '';
          var paymentDetail = transaction.paymentDetail;
          var roomDetails = {
            RoomNumber: null,
            ConfirmationNumber: null,
            LastName: null
          };
          var pointsDetails = {
            AccountNumber: null,
            BucketName: null,
            Name: null,
            LoyaltyTransactionId: null
          };

          if (transaction.paymentType == 1 || transaction.paymentType == 2) { //credit card
            name = paymentDetail.accountName;
          }

          if (transaction.paymentType == 3) { //Post to room charges
            roomDetails.RoomNumber = paymentDetail.cardIssuer;
            roomDetails.ConfirmationNumber = paymentDetail.cardNumber;
            roomDetails.LastName = paymentDetail.accountName;
            name = paymentDetail.accountName;
          }
          if (transaction.paymentType == 5) { //Loyalty
            pointsDetails.BucketName = paymentDetail.tender;
            pointsDetails.AccountNumber = paymentDetail.cardNumber;
            pointsDetails.Name = paymentDetail.accountName;
            pointsDetails.LoyaltyTransactionId = paymentDetail.followOnData;
            name = paymentDetail.accountName;
          }
          var dto = {
            CardNumber: paymentDetail.cardNumber ? paymentDetail.cardNumber : "",
            ExpirationDate: paymentDetail.expirationDate ? paymentDetail.expirationDate.substring(0, 4) + paymentDetail.expirationDate.substring(4) : "",
            Name: name ? name : "",
            Token: paymentDetail.token ? paymentDetail.token : null,
            TransactionFollowOnData: paymentDetail.followOnData ? paymentDetail.followOnData : null,
            AuthorizeTransactionID: transaction.authorizeTransactionID,
            Amount: transaction.paidAmount,
            PaymentType: transaction.paymentType ? transaction.paymentType : null,
            InvoiceID: transaction.invoiceID ? transaction.invoiceID : null,
            TransactionDate: transaction.transactionsDate ? transaction.transactionsDate : null,
            RoomNumber: roomDetails && roomDetails.RoomNumber ? roomDetails.RoomNumber : null,
            ConfirmationNumber: roomDetails && roomDetails.ConfirmationNumber ? roomDetails.ConfirmationNumber : null,
            BucketName: pointsDetails && pointsDetails.BucketName ? pointsDetails.BucketName : null,
            LoyaltyAccountNumber: pointsDetails && pointsDetails.AccountNumber ? pointsDetails.AccountNumber : null,
            LoyaltyTransactionId: pointsDetails && pointsDetails.LoyaltyTransactionId ? pointsDetails.LoyaltyTransactionId : null,
            IssuerType: pointsDetails && paymentDetail.tender ? paymentDetail.tender : null,
            AuthCode : paymentDetail?.authCode,
            CCType : paymentDetail?.cardIssuerType,
            CCTransactionId : paymentDetail?.payTransactionID,
          };
          authorizeTransactions.push(dto);
        } else if (transaction.errorMessage) {
          this.gs.setMessageState(transaction.errorMessage, 0);
        }
      });
      return authorizeTransactions;
    }
  }

  UpdateReservationAttempt(Dto) {
    this.gs.UpdateReservationAttempt(Dto).subscribe(data => {
      this.gs.setMessageState('', 0);
      if (data && (data.ErrorMessage || data.ExceptionMessage || (data.ValidationMessages && data.ValidationMessages.length > 0) || data.length == 0)) {
        if (data.ErrorMessage && data.ErrorMessage.length > 0) {
          var sorrysomethingwentwromg = this.ts.instant('SorryWeGotSomeErrorWhileProcessing');
          var CCUprocessableTryAgainErrorMessage = this.ts.instant('CCUprocessableTryAgainErrorMessage');
          var ImportantErrorMessage = this.ts.instant('ImportantErrorMessage');
          var CreditCardAuthorizationError = this.ts.instant('CreditCardAuthorizationError');
          var TryAgainMessage = this.ts.instant('TryAgainMessage');
          var CardNumbershouldContainOnlyDigits = this.ts.instant('CardNumbershouldContainOnlyDigits');
          var CardNumberShouldConsists13To16Digits = this.ts.instant('CardNumberShouldConsists13To16Digits');
          var CardNumberShouldNotBlank = this.ts.instant('CardNumberShouldNotBlank');
          var SorryWeGotSomeErrorCardExpired = this.ts.instant('SorryWeGotSomeErrorWhileProcessingCardExpired');
          if (data.ErrorMessage == "Please try it one more time, if the problem repeats, contact to rGuestSeat@Agilysys.com")
            var url = sorrysomethingwentwromg + TryAgainMessage;
          else if (data.ErrorMessage == "We're sorry, but we couldn�t process your credit card based on the information you provided. Please try again.")
            var url = sorrysomethingwentwromg + CCUprocessableTryAgainErrorMessage;
          else if (data.ErrorMessage == "[IMPORTANT] Some error happens at the moment of database saving. There is a probability that the payment transaction has performed successfully but this fact hasn't been saved properly. Don't try to do it one more time. Please, contact rGuestSeat@Agilysys.com regarding this error")
            var url = sorrysomethingwentwromg + ImportantErrorMessage;
          else if (data.ErrorMessage == "The provided credit card hasn't been authorized succesfully")
            var url = sorrysomethingwentwromg + CreditCardAuthorizationError;
          else if (data.ErrorMessage.indexOf("The card is expired") > 0)
            var url = SorryWeGotSomeErrorCardExpired;
          else if (data.ErrorMessage == "The card number should consist of only digits")
            var url = sorrysomethingwentwromg + CardNumbershouldContainOnlyDigits;
          else if (data.ErrorMessage == "The card number should consist of from 13 to 16 digits")
            var url = sorrysomethingwentwromg + CardNumberShouldConsists13To16Digits;
          else if (data.ErrorMessage == "The card number shouldn't be blank")
            var url = sorrysomethingwentwromg + CardNumberShouldNotBlank;
          else
            var url = sorrysomethingwentwromg + data.ErrorMessage;
          this.gs.setMessageState(url, 0);
        }
        else {
          var url = sorrysomethingwentwromg + TryAgainMessage;
          this.gs.setMessageState(url, 0);
        }
        this.gs.setMessageState(url, 0);
      } else if (data.RedirectUrl) {
        this.gs.offTimer();
        this.LoadPayment(data.RedirectUrl);
        setTimeout(() => {
          this.gs.setMessageState(this.ts.instant('yourCurrentPaymentOf') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + Dto.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + this.ts.instant('isProcessedSuccessfullyPleaseProceedToPay') + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.PendingAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + this.ts.instant('toPlaceYourReservation'), 1);
        }, 1);
        let timer = moment(data.ExtendedSlotLockResultDTO.ExpiresAt).diff(moment(data.ExtendedSlotLockResultDTO.LockedAt), "seconds");
        this.gs.showTimer = true;
        this.gs.runTimer(timer);
        this.isSplitPayment = true;
        this.gs.isSplitPayment$.next(true);

      }
      else {
        this.gs.isSplitPayment$.next(false);
        const ReservationIds = this.reservationAttemptIDsList; // this.paymentData.Slots?.map(x => x.ReservationAttemptId);
        this.gs.GetRegisterMultipleReservationAttempt(ReservationIds).subscribe(data => {
          if (data) {
            let isAuthorized = true;
            data.forEach(reservationData => {
              if (reservationData.State != PaymentStates.Authorized && reservationData.State != PaymentStates.ChargeCaptured) {
                isAuthorized = false;
              }
            });
            if (isAuthorized) {
              this.bookCartData();
            } else {
              this.gs.setMessageState(this.ts.instant("CreditCardNotBeProcessed"), 0);
            }
          }
        });

      }
    });
  }

  viewPartySummary(party) {
    this.gs.setMessageState('', 0);
    const parties = party.Parties;
    let partyType = PartyType.Reservation;
    if (party.SelectedActivity) {
      partyType = party.SelectedActivity.IsForStandbyReservations ? PartyType.StandBy : PartyType.Reservation;
      this.gs.SelectedActivity$.next(party.SelectedActivity);
    }
    if (parties && parties.length === 1) {
      this.getbyToken(parties[0].Token, '', partyType, party);
    } else if (parties && parties.length > 1) {
      this.getbyToken('', parties[0].BookingId, partyType, party);
    }
  }

  ngOnDestroy() {
    this.gs.offTimer();
    this.Subscriptions.unsubscribe();
  }

  getbyToken(token, bookingId, type, selectedBooking) {
    this.Subscriptions.add(this.gs.getByToken(token, bookingId, type).subscribe(party => {
      this.setBookingType(selectedBooking);
      this.gs.RatePlanList$.next(selectedBooking.RatePlan);
      this.gs.isSummaryFromCart = true;
      if (bookingId) {
        let PartiesData;
        if (Array.isArray(party)) {
          PartiesData = party;
        }
        else {
          PartiesData = [];
          PartiesData.push(party)
        }
        this.gs.bookingPartiesData$.next(PartiesData);
      } else {
        if (selectedBooking.BookingBehavior === BookingBehavior.ClassOrSession) {
          this.gs.editPartyData$.next(party);
        } else {
          this.gs.bookingPartiesData$.next([party]);
        }
      }
      this.gs.setAdditionalGuest();
      this.gs.TabChange$.next(ActivityTabs.ConfirmationSummary);
    }));
  }

  setAdditionalGuest() {
    const party = this.gs.editPartyData$.value;
    this.gs.additionalGuestPage = this.gs.restaurantWidgetSettings$.value.WidgetCustomization.AllowAdditionalGuestDetails;

    this.gs.additionalGuestRequired = party.size > 1 && (!party.SecondaryContacts || !party.SecondaryContacts.length) ? party.size - 1 : 0;
  }

  setBookingType(party) {
    if (party.BookingBehavior === BookingBehavior.ClassOrSession) {
      this.gs.TabChange$.next(ActivityTabs.ActivitySelection);
    } else if (party.BookingBehavior === BookingBehavior.OpenBooking) {
      this.gs.bookingSection$.next(BookingActivity.OpenBooking)
    } else if (party.BookingBehavior === BookingBehavior.PrivateLesson) {
      this.gs.bookingSection$.next(BookingActivity.PrivateLesson)
    }
  }

  backtosummaryBooking() {
    this.showIframeURL = false;
  }
}
